import { z } from 'zod';

// Service Request DTO
export const DeeplinkNavigationServiceRequestDtoSchema = z.object({
  url: z.string().min(1, '상품 링크 URL는 필수입니다'),
});

export type DeeplinkNavigationServiceRequest = z.infer<
  typeof DeeplinkNavigationServiceRequestDtoSchema
>;

export const DeeplinkNavigationServiceResponseDtoSchema = z.object({
  webUrl: z.string().url('올바른 웹 URL 형식이어야 합니다'),
  deeplinkUrl: z.string().url('올바른 딥링크 URL 형식이어야 합니다'),
});

export type DeeplinkNavigationServiceResponse = z.infer<
  typeof DeeplinkNavigationServiceResponseDtoSchema
>;
